module.exports = __webpack_public_path__ + "img/maggianos.12ae54fd.svg";